import get from 'lodash/get';
import moment from 'moment';
import { Component, Inject, OnInit } from '@angular/core';
import { ApiService, IOrderUser } from '@cakeiteasy/web-utils';
import { HttpParams } from '@angular/common/http';
import { UserApiService } from '../../../api-services/services/user-api.service';

@Component({
  standalone: false,
  selector: 'orders-history',
  templateUrl: './orders-history.component.html',
  styleUrls: ['./orders-history.component.scss']
})
export class OrdersHistoryComponent implements OnInit {
  public orders: IOrderUser[];
  public loaded: boolean = false;
  public loading: Promise<any>;
  public loadersMap: { [orderNumber: string]: Promise<void> } = {};

  constructor(private _userService: UserApiService,
              private _api: ApiService,
              @Inject('AppConfig') private _config: any) {
  }

  ngOnInit() {
    this._init();
  }

  public getOrderReceiptUrl(order) {
    if (!order) {
      return;
    }

    const bakeryOrder = get(order, 'bakeryOrders.0');
    const fileName = 'CIE_' + order.number + '.pdf';

    return this.loadersMap[bakeryOrder.id] = this._api.downloadFile('api.orders', 'receipt_url',
      { bakeryOrderId: bakeryOrder.id },
      fileName, {
        params: new HttpParams({ fromObject: { inline: 'true' } })
      });
  }

  public getDateFormat(date) {
    return moment(date).format('DD MMM YY');
  }

  public getCurrency(order) {
    return get(order, 'bakeryOrders.0.bakery.country.currencySymbol') || 'kr';
  }

  private _init() {
    this.loading = this._userService.getOrders()
      .then((orders) => {
        this.loaded = true;
        this.orders = orders;
      });
  }

  isOrderFromOldStore(order: IOrderUser): boolean {
    return order.source === 'OLD_STORE';
  }

  isOrderFromAdminPanel(order: IOrderUser): boolean {
    return order.source === 'ADMIN';
  }
}
